export default class DeleteReflectionCtrl {

	constructor($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
		var deleteReflectionVm = this
		const shared = PortfolioModalSrv.getVariable()

		deleteReflectionVm.reflection = shared.reflection
		deleteReflectionVm.userId = shared.userId
		deleteReflectionVm.startDate = shared.startDate
		deleteReflectionVm.endDate = shared.endDate

		//methods declaration
		deleteReflectionVm.close = close
		deleteReflectionVm.deleteReflection = deleteReflection

		activate()
	
		//initial functions
		function activate() {
			setValues()
			getEvidences()
		}

		function getEvidences() {
			let header = {
				userId   : deleteReflectionVm.userId,
				startDate: deleteReflectionVm.startDate,
				endDate  : deleteReflectionVm.endDate,
			}

			PortfolioSrv.getEvidences.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					deleteReflectionVm.evidences = dataReturn.data
				}
			}, function(data) {
				console.log(data)
			})
		}

		function setValues() {
			deleteReflectionVm.blogId = deleteReflectionVm.reflection.blogId
			deleteReflectionVm.description = deleteReflectionVm.reflection.blogDescription
			deleteReflectionVm.title = deleteReflectionVm.reflection.blogtitle
			deleteReflectionVm.blogIsEnlighted = deleteReflectionVm.reflection.blogIsEnlighted
			deleteReflectionVm.evidencesLinks = deleteReflectionVm.reflection.evidences
		}

		function close () {
			PortfolioModalSrv.setVariable({ status: false })

			return $mdDialog.hide()
		}

		function deleteReflection() {
			let header = {
				blogId: deleteReflectionVm.blogId,
			}

			console.log(header)
			PortfolioSrv.deleteReflection.delete(header).$promise.then((dataReturn) => {

				if (dataReturn.status) {
					PortfolioModalSrv.setVariable({ status: dataReturn.status })

					return $mdDialog.hide()
				}
			})
		}
	}

}

DeleteReflectionCtrl.$inject = [ '$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 
	'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT' ]


// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/deleteReflectionCtrl.js